import React, { useState } from 'react';
import { SurveyImportElementsAndUnitsNotFoundError } from '../../../../common/src/imports/surveyImport';
import { openApiFetch } from '../../store/openApiFetch';
import { PanelButton, Table, TableBody, TableData, TableHead, TableHeader, TableHeadRow, TableRow } from '../elements';
import { SmallSpinner } from '../spinners';

export function SurveyImportElementsNotFoundErrorRow(props: {
    error: SurveyImportElementsAndUnitsNotFoundError;
    clientCompanyId: string | undefined;
    ownerCompanyId: string | undefined;
}) {
    const [isLoading, setIsLoading] = useState(false);
    const [resultMessage, setResultMessage] = useState<string | undefined>();

    async function createCompositions() {
        setIsLoading(true);
        if (!props.clientCompanyId) {
            setResultMessage('clientCompanyId missing');
        } else if (!props.ownerCompanyId) {
            setResultMessage('ownerCompanyId missing');
        } else {
            try {
                await openApiFetch(
                    '/api/objects/composition/bulkCreate',
                    'post',
                    {},
                    {
                        elements: props.error.elements,
                        units: props.error.units,
                        clientCompanyId: props.clientCompanyId,
                        ownerCompanyId: props.ownerCompanyId,
                    },
                );
            } catch (_error) {
                setResultMessage('Error creating compositions');
            }
        }
        setResultMessage('Compositions created, please reupload the file.');

        setIsLoading(false);
    }

    async function deleteCompositions() {
        setIsLoading(true);
        try {
            await openApiFetch('/api/objects/composition/bulkDelete', 'post', {}, { objectIds: props.error.objectsWithComposition.map((i) => i.id) });
        } catch (_error) {
            setResultMessage('Error archiving compositions');
        }
        setResultMessage('Compositions deleted, please reupload the file.');

        setIsLoading(false);
    }
    return (
        <>
            <div>Missing elements/units in {props.error.sheet} sheet.</div>
            {resultMessage && <div>{resultMessage}</div>}

            {!isLoading && !resultMessage && (
                <>
                    {props.error.objectsWithComposition.length > 0 && (
                        <>
                            <div>There are {props.error.objectsWithComposition.length} objects with a composition</div>
                            <div>
                                <PanelButton text="Delete all existing compositions" onClick={deleteCompositions}></PanelButton>
                            </div>
                        </>
                    )}
                    <div>
                        <PanelButton text="Create compositions" onClick={createCompositions}></PanelButton>
                    </div>
                </>
            )}
            {isLoading && <SmallSpinner />}
            <Table>
                <TableHead>
                    <TableHeadRow light={false}>
                        <TableHeader>Object code</TableHeader>
                        <TableHeader>Element code</TableHeader>
                        <TableHeader>Element name</TableHeader>
                    </TableHeadRow>
                </TableHead>
                <TableBody>
                    {props.error.elements.map((i) => (
                        <TableRow key={`${i.objectCode}-${i.elementCode}-${i.elementName}`}>
                            <TableData>{i.objectCode}</TableData>
                            <TableData>{i.elementCode}</TableData>
                            <TableData>{i.elementName}</TableData>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
            <Table>
                <TableHead>
                    <TableHeadRow light={false}>
                        <TableHeader>Object code</TableHeader>
                        <TableHeader>Element code</TableHeader>
                        <TableHeader>Element name</TableHeader>
                        <TableHeader>Unit code</TableHeader>
                        <TableHeader>Unit name</TableHeader>
                    </TableHeadRow>
                </TableHead>
                <TableBody>
                    {props.error.units.map((i) => (
                        <TableRow key={`${i.objectCode}-${i.elementCode}-${i.elementName}-${i.unitCode}-${i.unitName}`}>
                            <TableData>{i.objectCode}</TableData>
                            <TableData>{i.elementCode}</TableData>
                            <TableData>{i.elementName}</TableData>
                            <TableData>{i.unitCode}</TableData>
                            <TableData>{i.unitName}</TableData>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </>
    );
}
